import { createRouter, createWebHistory } from 'vue-router';

// import tokenHelper from '@/helpers/token_helper'

import userHelper from "@/helpers/user_helper";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import('../views/Home.vue'),
  },
  {
    path: '/auths/WechatAuth',
    name: 'wechat_auth',
    component: () =>
      import('../views/auths/WechatAuth.vue'),
  },
  //SecretKey登录授权
  {
    path: '/auths/SecretKeyAuth',
    name: 'SecretKeyAuth',
    component: () =>
      import('../views/auths/SecretKeyAuth.vue'),
  },
  {
    path: '/user/payment',
    name: 'Payment',
    component: () =>
      import('../views/user/Payment.vue'),
      meta: {
        requiresAuth: true,
      }
  },
 

  //输入电桩序列号
  {
    path: '/user/input_serial_number',
    name: 'InputSerialNumber',
    component: () =>
      import('../views/user/InputSerialNumber.vue'),
  },
  //发票详情
  {
    path: '/user/receipt/details/:id',
    name: 'Details',
    component: () =>
      import('../views/user/receipt/Details.vue'),
    meta: { requiresAuth: true }
  },
  //确认开票
  {
    path: '/user/receipt/affirm',
    name: 'Affirm',
    component: () =>
      import('../views/user/receipt/Affirm.vue'),
    meta: { requiresAuth: true }
  },
  //发票开票成功
  {
    path: '/user/receipt/success',
    name: 'Success',
    component: () =>
      import('../views/user/receipt/Success.vue'),
    meta: { requiresAuth: true }
  },
  //发票正在开票包含的列表
  {
    path: '/user/receipt/include_list',
    name: 'IncludeList',
    component: () =>
      import('../views/user/receipt/IncludeList.vue'),
    meta: { requiresAuth: true }
  },
  //运营商发票记录
  {
    path: '/user/receipt/receipt_record/:id',
    name: 'ProviderReceiptRecord',
    component: () =>
      import('../views/user/receipt/ReceiptRecord.vue'),
    meta: { requiresAuth: true }
  },
  //发票记录
  {
    path: '/user/receipt/receipt_record',
    name: 'ReceiptRecord',
    component: () =>
      import('../views/user/receipt/ReceiptRecord.vue'),
    meta: { requiresAuth: true }
  },
  //发票抬头列表
  {
    path: '/user/receipt/title_list',
    name: 'TitleList',
    component: () =>
      import('../views/user/receipt/TitleList.vue'),
    meta: { requiresAuth: true }
  },
  //发票管理中心
  {
    path: '/user/receipt/container',
    name: 'Container',
    component: () =>
      import('../views/user/receipt/Container.vue'),
    meta: { requiresAuth: true }
  },
  //发票抬头编辑
  {
    path: '/user/receipt/title_editor',
    name: 'TitleEditor',
    component: () =>
      import('../views/user/receipt/TitleEditor.vue'),
    meta: { requiresAuth: true }
  },
  //发票可开票列表
  {
    path: '/user/receipt/index_list',
    name: 'ReceiptList',
    component: () =>
      import('../views/user/receipt/IndexList.vue'),
    meta: { requiresAuth: true }
  },
  //充值
  {
    path: '/user/recharge',
    name: 'Recharge',
    component: () =>
      import('../views/user/Recharge.vue'),
    meta: { requiresAuth: false }
  },
  //钱包
  {
    path: '/user/wallet',
    name: 'Wallet',
    component: () =>
      import('../views/user/Wallet.vue'),
    meta: { requiresAuth: true }
  },
   //提现
   {
    path: '/user/withdrawal',
    name: 'Withdrawal',
    component: () =>
      import('../views/user/Withdrawal.vue'),
    meta: { requiresAuth: true }
  },
     //提现记录
     {
      path: '/user/withdrawal_record',
      name: 'WithdrawalRecord',
      component: () =>
        import('../views/user/WithdrawalRecord.vue'),
      meta: { requiresAuth: true }
    },
  //充电中
  {
    path: '/station/Charging/:id',
    name: 'charging',
    component: () =>
      import('../views/station/Charging.vue'),
    meta: { requiresAuth: true }
  },
  //登录页面
  {
    path: '/auths/sign_in/:id',
    name: 'SignIn',
    component: () =>
      import('../views/auths/SignIn.vue'),
  },
  //订单记录
  {
    path: '/user/orders_list',
    name: 'OrdersList',
    component: () =>
      import('../views/user/OrdersList.vue'),
    meta: { requiresAuth: true }
  },
  //订单详情
  {
    path: '/user/orders_details/:id',
    name: 'ordersDetails',
    component: () =>
      import('../views/user/OrdersDetails.vue'),
    meta: { requiresAuth: true }
  },
  //订单金额明细
  {
    path: '/user/order_billing_details/:id',
    name: 'OrderBillingDetails',
    component: () =>
      import('../views/user/OrderBillingDetails.vue'),
    meta: { requiresAuth: true }
  },
  //点金计划
  {
    path: '/user/cash_point_plan',
    name: 'cashPointPlan',
    component: () =>
      import('../views/user/CashPointPlan.vue'),
  },
  //电站详情
  {
    path: '/station/details/:id',
    name: 'details',
    component: () =>
      import('../views/station/Details.vue'),
    meta: {
      keepAlive: true, //此组件不需要被缓存
      isBack:false
    }
  },
  //电桩详情
  {
    path: '/station/charge_details/:id',
    name: 'ChargeDetails',
    component: () =>
      import('../views/station/ChargeDetails.vue'),
  },
   //充电启动
   {
    path: '/station/staring_charging/:id',
    name: 'StaringCharging',
    component: () =>
      import('../views/station/StaringCharging.vue'),
    meta: { requiresAuth: false }
  },
  //充电成功页面
  {
    path: '/station/Account/:id',
    name: 'Account',
    component: () =>
      import('../views/station/Account.vue'),
    meta: { requiresAuth: true }
  },
  //费率
  {
    path: '/station/Rate/:id',
    name: 'Rate',
    component: () =>
      import('../views/station/Rate.vue'),
  },
  //微信登录授权
  {
    path: '/auths/wechat_authorized',
    name: 'WechatAuthorized',
    component: () =>
      import('../views/auths/WechatAuthorized.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to,from)=>{
  if(from.name != 'wechat_auth' && from.name != 'WechatAuthorized'  && from.name != 'SignIn'){
    userHelper.storeLastRouter(from.name)
  }
  if(to.name != 'wechat_auth' && to.name != 'WechatAuthorized' && to.name != 'SignIn'){
    userHelper.storeRouterSession(to.fullPath)
  }
  
})

export default router;
